import * as React from "react";
import {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import Modal from "react-responsive-modal";
import AgHelpToolTip, {helpHeaderTemplate} from "../common/AgHeaderHelpToolTip";
import * as agGrid from "ag-grid-community";
import Axios from "../../../config/Axios";
import * as toastr from "toastr";
import urlencode from "urlencode";
import Select from 'react-select';
import {
    getBusinessObjectClassById,
    getRelationshipTypesByBoId,
    importV2,
    importNaturalKeys
} from "../../../actions/boCoreActions";
import {AttributeTypeEnum} from "../enums/AttributeTypeEnum";
import Utils from "../../../Utils";
import AgSelectAllHeader from "../common/AgSelectAllHeader";
import ActionSpinner from "../../common/ActionSpinner";
import AgGridUtils from "../../../AgGridUtils";
import {useSelector} from "react-redux";

const AgGridReact = require('ag-grid-react').AgGridReact;

let selectedRelationship;

const RelationshipsModal = forwardRef((props: any, ref) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [grid, setGrid] = useState<any>(null);
    const [importedFilesGrid, setImportedFilesGrid] = useState<any>(null);
    const [businessObject, setBusinessObject] = useState<any>(null);
    const [instanceName, setInstanceName] = useState<string>("");
    const [instance, setInstance] = useState<any>(null);
    const [relType, setRelType] = useState(null);
    const [relTypes, setRelTypes] = useState(null);
    const [selectedBoClassId, setSelectedBoClassId] = useState(-1);
    const [isAttributesGrid, setAttributesGrid] = useState(false);
    const [importId, setImportId] = useState(-1);
    const [relationshipsColumnDefs, setRelationshipsColumnDefs] = useState([]);
    const [rowDataRelationships, setRowDataRelationships] = useState([]);
    const [selectedRelationTypeNode, setSelectedRelationTypeNode] = useState(null);
    const [instanceRelationships, setInstanceRelationships] = useState<any>([]);
    const [gridApi, setGridApi] = useState(null);
    const locale = useSelector((store: any) => store.auth.locale);
    let update = false;

    useEffect(() => {
        if (selectedRelationTypeNode) {
            selectedRelationTypeNode.node.setSelected(true);
            onChangeRelType(selectedRelationTypeNode.data);
        }
    }, [selectedRelationTypeNode])

    useEffect(() => {
        if (gridApi) {
            if (selectedRelationTypeNode === null) {
                setTimeout(() => {
                    gridApi.forEachNode(node=> node.rowIndex ? 0 : node.setSelected(true))
                },100)
            }
        }
    },[rowDataRelationships])

    const $importTargetContentModel = Utils.$('<div></div>')
        .append($("<label>What is the multi-value separator in the import file?</label>"))
        .append($("<input id='multiValueToggle' type='checkbox' data-onstyle='danger' data-offstyle='primary' data-toggle='toggle' data-width='100%' data-height='20'/>"))
        .append($("<div style='padding-top: 5px' id='buttons-container'/>")
            .append($("<input id='choose-files' style='float: left' type='file' accept='.tsv' />"))
            .append($("<input id='submit-files' type='button' style='float: right; color: black' value='Submit'/>")));

    const [$importTargetContent, setImportTargetContent] = useState($importTargetContentModel.clone());

    const onOpenImportDialog = (e) => {
        const importTargetContent = $importTargetContent.clone();
        Utils.$(e.target).qtip({
            content: {
                title: function () {
                    return "Business Object Instances Import"
                },
                text: importTargetContent,
                button: "Close"
            },
            show: true,
            hide: "unfocus",
            events: {
                show: () => {
                    $(e.target).css("background-color", "#676A6C");
                },
                hide: () => {
                    Utils.$(e.target).css("background-color", "#1AB394");
                    Utils.$(e.target).qtip('destroy');
                },
                render: () => {
                    let multiValueFormat = "PIPE";
                    let $multiValueToggle = importTargetContent.children("#multiValueToggle").bootstrapToggle({
                        height: 30,
                        on: 'JSON',
                        off: 'PIPE'
                    });
                    $multiValueToggle.focus().select();
                    $multiValueToggle.change(function () {
                        if ($multiValueToggle[0].checked) {
                            multiValueFormat = "JSON";
                            Utils.$('#choose-files').attr('disabled','disabled');
                            Utils.$('#submit-files').attr('disabled','disabled');
                        } else {
                            multiValueFormat = "PIPE";
                            Utils.$('#choose-files').removeAttr('disabled');
                            Utils.$('#submit-files').removeAttr('disabled');
                        }
                    });
                    Utils.$("#submit-files")
                        .unbind()
                        .on("click", () => {
                            const file = Utils.$("#choose-files").prop("files")[0];
                            if(file) {
                                ActionSpinner.get(`/type/${selectedBoClassId}`, {}, {key: "getResourceType", showOnError: true},false)
                                    .then(response => {
                                       if (response) {
                                           importV2(file,multiValueFormat, response.data.boKey)
                                               .then(response => {
                                                   if (response) {
                                                       let areThereIDs = false;
                                                       setImportId(response.data.importId);
                                                       response.data.instances.forEach(instance => {
                                                           if (instance.id) {
                                                               areThereIDs = true;
                                                           }
                                                       });
                                                       if (areThereIDs) {
                                                           Utils.$('.qtip-dark').remove();
                                                           Utils.$.confirm({
                                                               title: 'Confirm?',
                                                               keyboardEnabled: true,
                                                               escapeKey: 'cancel',
                                                               backgroundDismiss: false,
                                                               content: 'There is primary key column present in this import. All existing instances will be updated and all non-existing will be created.',
                                                               type: 'red',
                                                               theme: 'dark',
                                                               typeAnimated: false,
                                                               buttons: {
                                                                   ok: {
                                                                       text: "Yes!",
                                                                       btnClass: 'btn-danger',
                                                                       keys: ['enter'],
                                                                       action: () => {
                                                                           importNaturalKeys(response.data.importId, [])
                                                                               .then(() => {
                                                                                   grid.destroy();
                                                                                   setGrid(null);
                                                                                   setAttributesGrid(false);
                                                                                   update = true;
                                                                                   show(businessObject,instanceName,instance, instanceRelationships);
                                                                               })
                                                                       }
                                                                   },
                                                                   cancel: function () {
                                                                   }
                                                               }
                                                           });
                                                       } else {
                                                           prepareForNextGrid();
                                                           Utils.$('#relationships').html('');
                                                           setAttributesGrid(true);
                                                           buildGridFromImportedFile(response.data);
                                                       }
                                                   }
                                               })
                                       }
                                    })
                                    .catch(() => {
                                        Utils.$(e.target).css("background-color", "#1AB394");
                                        Utils.$(e.target).qtip('destroy');
                                    })
                            }else{
                                toastr.warning("Please attach a file first.")
                            }
                        })
                }
            },
            position: {
                my: 'top right',
                at: 'bottom center',
                viewport: $(document.body)
            },
            style: {
                classes: 'qtip-dark',
                width: 350
            }
        });
    };

    const show = (businessObject: any, instanceName: string, instance: any, instanceRelationshipsValues: any) => {
        if (!update) {
            setIsOpen(true);
        }
        setAttributesGrid(false);
        setInstance(instance);
        setInstanceName(instanceName);
        setBusinessObject(businessObject);
        setInstanceRelationships(instanceRelationshipsValues)

        getRelationshipTypesByBoId(businessObject.id)
            .then(response => {
                setRelTypes(response.data);
                const rowData = createRelationshipsData(response.data, businessObject, instanceName);
                buildRelationshipsGrid(rowData);
                if (update) {
                    if (relType) {
                        getBusinessObjectClassById(relType.value)
                            .then(response => {
                                setSelectedBoClassId(response.data.id);
                                buildGrid(response.data, instanceRelationshipsValues);
                                update = false;
                            })
                    }
                } else {
                    const rel = rowData[0].item;
                    if (rel) {
                        let relType: any;
                        if (rel.fromBoClass.id === businessObject.id) {
                            relType = {
                                relTypeId: rel.id,
                                fromClass: true,
                                value: rel.toBoClass.id,
                                name: rel.name,
                                type: rel.toBoClass.name,
                                inward: rel.inward,
                                outward: rel.outward
                            };
                        } else {
                            relType = {
                                relTypeId: rel.id,
                                fromClass: false,
                                value: rel.fromBoClass.id,
                                name: rel.name,
                                type: rel.fromBoClass.name,
                                inward: rel.inward,
                                outward: rel.outward
                            };
                        }
                        setRelType(relType);
                        selectedRelationship = relType;
                        if (relType) {
                            getBusinessObjectClassById(relType.value)
                                .then(response => {
                                    setSelectedBoClassId(response.data.id);
                                    buildGrid(response.data, instanceRelationshipsValues);
                                })
                        }
                    }
                }
            })
    };

    const hide = () => {
        if (isAttributesGrid) {
            setImportedFilesGrid(null);
            setIsOpen(false);
            Utils.$('.qtip-dark').remove();
        } else {
            setGrid(null);
            setRelType(null);
            selectedRelationship = null;
            setIsOpen(false);
            setRelTypes(null);
            setInstanceName("");
            setBusinessObject(null);
            setAttributesGrid(false);
            Utils.$('.qtip-dark').remove();
        }
        setSelectedRelationTypeNode(null);
    };

    const destroyRelGrid = () => {
        setGrid(null);
        setRelType(null);
        selectedRelationship = null;
        setRelTypes(null);
        setInstanceName("");
        setBusinessObject(null);
        setAttributesGrid(false)
        Utils.$('.qtip-dark').remove();
    };

    const prepareForNextGrid = () => {
        setGrid(null);
        setAttributesGrid(false);
        Utils.$('.qtip-dark').remove();
    }

    useImperativeHandle(ref, () => {
        return {
            show: show,
            hide: hide
        };
    });

    const createRelationshipsData = (types: any, businessObject, instanceName) => {
        let rowData = [];
        if (types) {
            types.forEach(item => {
                rowData.push({
                    relTypeId: item.id,
                    value: item.fromBoClass.id === businessObject.id ? item.toBoClass.id : item.fromBoClass.id,
                    name: item.name,
                    type: item.fromBoClass.id === businessObject.id ? item.toBoClass.name : item.fromBoClass.name,
                    relationship: item.fromBoClass.id === businessObject.id ?
                        `${businessObject.name} (${instanceName}) ${item.inward}` : `${businessObject.name} (${instanceName}) ${item.outward}`,
                    fromClass: item.fromBoClass.id === businessObject.id,
                    arrow: item.fromBoClass.id === businessObject.id ? 'right' : 'left',
                    item: item
                });
                if (item.toBoClass.id === item.fromBoClass.id) {
                    rowData.push({
                        relTypeId: item.id,
                        value: item.fromBoClass.id,
                        name: item.name,
                        type: item.fromBoClass.name,
                        relationship: item.fromBoClass.id === businessObject.id ?
                            `${businessObject.name} (${instanceName}) ${item.outward}` : `${businessObject.name} (${instanceName}) ${item.inward}`,
                        fromClass: item.fromBoClass.id !== businessObject.id,
                        arrow: item.fromBoClass.id !== businessObject.id ? 'right' : 'left'
                    });
                }
            });
            rowData = rowData.sort((a,b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0));
        }
        return rowData;
    }

    const buildRelationshipsGrid = (rowData: any) => {
        const columnDefs = [
            {
                id: "relationship",
                headerName: "Relationship",
                field: "relationship",
                headerTooltip: "relationship",
                type: 'text',
                cellRenderer: (params) => {
                    return `<span title="${params.value}">${params.value}</span>`
                }
            },
            {
                id: "arrow",
                headerName: "",
                field: "arrow",
                headerTooltip: "",
                type: 'text',
                width: 50,
                suppressSizeToFit: true,
                cellRenderer: (params) => {
                    if (params.value === 'right') {
                        return `<span style="display: flex;justify-content: center;align-items: center;height: 100%;"><i class='fas fa-arrow-right' style="font-size: 20px"></i></span>`
                    } else {
                        return `<span style="display: flex;justify-content: center;align-items: center;height: 100%;"><i class='fas fa-arrow-left' style="font-size: 20px"></i></span>`
                    }
                }
            },
            {
                field: 'type',
                headerName: "Related Type",
                tooltipField: 'fromRelName',
                headerTooltip: "fromRelName",
                cellRenderer: (params) => {
                    return `<span title="${params.value}">${params.value}</span>`
                }
            }
        ];
        setRelationshipsColumnDefs(columnDefs);
        setRowDataRelationships(rowData);
    }


    const buildGrid = (businessObject, instanceRelationshipsValues) => {
        const columnDef: any [] = businessObject.attributes.map(item => {
            return {
                field: item.key,
                headerName: item.name,
                width: 150,
                minWidth: 85
            }
        });

        columnDef.unshift({
            field: "id",
            headerName: "ID",
            checkboxSelection: true,
            headerComponent: AgSelectAllHeader,
            width: 100,
            minWidth: 85
        });

        const gridOptions: any = {
            defaultColDef: {
                resizable: true,
                sortable: true,
                filter: "agTextColumnFilter",
                tooltipComponent: AgHelpToolTip,
                filterParams: {
                    filterOptions: ['contains'],
                    applyButton: true,
                    clearButton: true,
                    suppressAndOrCondition: true
                },
                headerComponentParams: {
                    template: helpHeaderTemplate
                },
                floatingFilterComponentParams: {suppressFilterButton: true},
                menuTabs: ['generalMenuTab']
            },
            onGridReady: (params: any) => {
                params.api.sizeColumnsToFit();
            },
            onPaginationChanged: params => setSelectedRelationshipRecords(params),
            onFirstDataRendered: params => setSelectedRelationshipRecords(params),
            onRowSelected: (params) => {
                const rel = instanceRelationshipsValues.find(item => item.relatedRecord.id === params.node.data.id);
                if (rel) {
                    rel['removedByUser'] = !params.node.selected;
                }
                params.node.data.removedByUser = !params.node.selected;
                params.api.redrawRows();
            },
            getRowNodeId: (data) => {
                return data.id;
            },
            rowClassRules: {
                'deleted-relationship-row-background': function (params) {
                    let rel;
                    if (instanceRelationshipsValues && params.node.data) {
                        const copy = JSON.parse(JSON.stringify(instanceRelationshipsValues))
                        rel = copy.find(item => item.relatedRecord.id === params.node.data.id);
                        if (rel) {
                            return params.node.data.removedByUser === true;
                        }
                    }
                }
            },
            suppressPropertyNamesCheck: true,
            suppressDragLeaveHidesColumns: true,
            suppressRowClickSelection: true,
            suppressCellSelection: true,
            columnDefs: columnDef,
            floatingFilter: true,
            rowSelection: 'multiple',
            rowModelType: 'serverSide',
            cacheBlockSize: 100,
            maxBlocksInCache: 500,
            maxConcurrentDatasourceRequests: 2,
            enableCellTextSelection: true,
            ensureDomOrder: true,
            animateRows: true,
            debug: false
        };

        const setSelectedRelationshipRecords = (params: any) => {
            if (params) {
                instanceRelationshipsValues.forEach(item => {
                    let found;
                    if (selectedRelationship) {
                        if (selectedRelationship.fromClass) {
                            if (item.relatedRecord.id === item.toBoInstance.id && selectedRelationship.relTypeId === item.relTypeId) {
                                found = params.api.getRowNode(item.relatedRecord.id);
                            }
                        } else {
                            if (item.relatedRecord.id === item.fromBoInstance.id && selectedRelationship.relTypeId === item.relTypeId) {
                                found = params.api.getRowNode(item.relatedRecord.id);
                            }
                        }
                    }

                    if (found) {
                        if (!found.data.removedByUser) {
                            found.setSelected(true)
                        }
                        // found.selectable = false;
                    }
                })
            }
        }

        const grid = new agGrid.Grid(document.getElementById("relationships"), gridOptions);
        gridOptions.api.setServerSideDatasource(ServerSideDatasource(businessObject.id, "full"));
        setGrid(grid);
    };

    const buildGridFromImportedFile = (data) => {
        const gridOptions: any = {
            defaultColDef: {
                filter: "agTextColumnFilter",
                sortable: true,
                resizable: true
            },
            rowData: [],
            suppressDragLeaveHidesColumns: true,
            floatingFilter: true,
            animateRows: true,
            debug: false,
            rowSelection: 'multiple',
            columnDefs: [
                {
                    field: "Attributes",
                    headerName: "Attributes",
                    checkboxSelection: true,
                    headerComponent: AgSelectAllHeader
                }
            ],
            onGridReady: (params: any) => {
                params.api.sizeColumnsToFit();
            },
        };

        data.instances.forEach(instanceAttr => {
            gridOptions.rowData = [];
            const uniqueAttr = new Set(Object.getOwnPropertyNames(instanceAttr.attributes));

            uniqueAttr.forEach(name => {
                gridOptions.rowData.push({Attributes: name})
            })
        });
        const grid: any = new agGrid.Grid(document.getElementById("relationships"), gridOptions);

        gridOptions.api.getAllRows = (): any[] => {
            const data = [];
            gridOptions.api.rowModel.gridApi.forEachNode((node) => {
                if (!node.group)
                    data.push(node.data);
            });
            return data
        };

        setImportedFilesGrid(grid);
    };

    const submitNaturalKeys = () => {
        const rows = importedFilesGrid.gridOptions.api.getSelectedRows();
        let attributesArr = [];
        if (rows.length > 0 ) {
            rows.forEach(row => {
                attributesArr.push(row.Attributes);
            })
        }
        importNaturalKeys(importId,attributesArr)
            .then(() => {
                importedFilesGrid.destroy();
                update = true;
                show(businessObject,instanceName,instance, instanceRelationships);
            })
    }

    const ServerSideDatasource = (id: number, dataView: string) => {
        return {
            getRows: (params: any) => {
                const limit = params.request.endRow - params.request.startRow;
                const page = (params.request.endRow / limit) - 1;
                const sort = AgGridUtils.generateSortData(params.request.sortModel);
                const filter = AgGridUtils.generateFilterData(params);

                Axios.instance.post(`boi/data/${id}?dataFormat=MAP&dataView=${urlencode(dataView)}&limit=${limit}&page=${page}`, {
                    filter: JSON.stringify(filter),
                    searchText: params.request.filterModel.quickFilter ? params.request.filterModel.quickFilter.filter : "",
                    sort: JSON.stringify(sort)
                })
                    .then((response: any) => {

                        const dataArray = response.data.content.map(item => {
                            const base = {
                                id: item.id,
                                tags: item.tags,
                                removedByUser: false,
                                updated: Utils.moment(item.updated, Utils.moment.ISO_8601).isValid() ? Utils.moment.utc(item.updated).utcOffset(Utils.moment(item.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss') : item.updated
                            };
                            const custom = {};
                            Object.keys(item.data).map((key, index) => {
                                switch (response.data.dataView.attributes[index].attribute.type) {
                                    case AttributeTypeEnum.INT:
                                    case AttributeTypeEnum.DECIMAL:
                                        custom[key] = Utils.numberFormatByLocale(item.data[key], locale.value);
                                        break;
                                    case AttributeTypeEnum.TIMESTAMP:
                                        custom[key] = Utils.moment(item.data[key], Utils.moment.ISO_8601).isValid() ? Utils.moment.utc(item.data[key]).utcOffset(Utils.moment(item.data[key]).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss') : item.data[key];
                                        break;
                                    case AttributeTypeEnum.LOOKUP:
                                        custom[key] = JSON.parse(item.data[key]).value;
                                        break;
                                    default:
                                        custom[key] = item.data[key];
                                }
                            });
                            return {
                                ...base,
                                ...custom
                            }
                        });
                        try {
                            const lastRow = dataArray.length < limit ? params.request.startRow + dataArray.length : -1;
                            params.successCallback(dataArray, lastRow);
                        } catch (e) {
                            console.error(e);
                        }
                    })
                    .catch((e) => {
                        AgGridUtils.serverSideErrorHandler(e)
                        params.failCallback();
                    })
            }
        }
    };

    const onChangeRelType = (item) => {
        setRelType(item);
        selectedRelationship = item;
        grid.destroy();
        getBusinessObjectClassById(item.value)
            .then(response => {
                setSelectedBoClassId(response.data.id);
                buildGrid(response.data, instanceRelationships);
            })
    };

    const onSave = () => {
        const rows = grid.gridOptions.api.getSelectedRows();
        const toRelationships = [];
        const fromRelationships = [];
        if (rows.length > 0) {
            rows.forEach(item => {
                if (relType.fromClass) {
                    fromRelationships.push({
                        relTypeId: relType.relTypeId,
                        toBoInstanceId: item.id,
                        relGridItem: {
                            id: -1,
                            relationship: relType.name,
                            type: relType.type,
                            description: `${instanceName} ${relType.inward} ${item.name}`,
                            relatedRecord: {
                                id: item.id,
                                name: item.name
                            },
                            tags: [],
                            updated: "",
                            removedByUser: item.removedByUser
                        }
                    });
                } else {
                    toRelationships.push({
                        relTypeId: relType.relTypeId,
                        fromBoInstanceId: item.id,
                        relGridItem: {
                            id: -1,
                            relationship: relType.name,
                            type: relType.type,
                            description: `${instanceName} ${relType.outward} ${item.name}`,
                            relatedRecord: {
                                id: instance.id,
                                name: instanceName
                            },
                            tags: [],
                            updated: "",
                            removedByUser: item.removedByUser
                        }
                    })
                }
            });
        }
        props.save({
            toRelationships,
            fromRelationships
        });
    };

    const onAttrGridReady = (params) => {
        setGridApi(params.api);
        params.api.sizeColumnsToFit();
    }

    const onRelationshipSelect = (params) => {
        if (isAttributesGrid) {
            return;
        }
        setSelectedRelationTypeNode(params)
    }

    return (
        <Modal
            center
            focusTrapped={true}
            open={isOpen}
            styles={{
                overlay: {zIndex: 10000},
                closeButton: {display: "none"},
                modal: {
                    width: '95%',
                    padding: 0,
                    maxWidth: '95%',
                }
            }}
            closeOnEsc={true}
            closeOnOverlayClick={true}
            onClose={() => {
                hide();
            }}
        >
            <h2 style={{margin: 0, background: '#2D3436', borderBottom: "2px solid #f5f5f5a3",
                width: "100%", textAlign: "center", fontSize: 20, padding: 5, fontWeight: 600, color: '#f5f5f5a3'}}>
                { !isAttributesGrid ? 'Edit Relationships' : 'Please Select Attributes to Match Rows On (or continue to create new records for all data being imported)'}
            </h2>
            <div style={{width: "100%", height: "calc(100vh - 135px)", background: "#2D3436"}}>
                <div style={{display: "flex", height: '100%', padding: '5px 5px 0 5px'}}>
                    <div style={{width: "35%", height: "100.5%"}}>
                        <header className={'instance-layout-grid-header'}><h5>Relationships</h5></header>
                        <div style={{width: "100%", height: "calc(100% - 40px)"}} id={'rel-types'}
                             className={"ag-theme-balham-dark ag-grids"}>
                            <AgGridReact
                                onGridReady         = {onAttrGridReady}
                                onFirstDataRendered = {onAttrGridReady}
                                columnDefs          = {relationshipsColumnDefs}
                                rowData             = {rowDataRelationships}
                                onCellClicked       = {onRelationshipSelect}
                                defaultColDef={{
                                    resizable: true,
                                    minWidth: 150,
                                    flex: 1,
                                    floatingFilterComponentParams: {suppressFilterButton: true},
                                    floatingFilter: false
                                }}
                                gridOptions={{
                                    resizable: true,
                                    suppressDragLeaveHidesColumns: true,
                                    suppressCellSelection: true,
                                    enableCellTextSelection: true
                                }}
                            >
                            </AgGridReact>
                        </div>
                    </div>
                    <div id={'spacer'} style={{width: 5}}/>
                    <div style={{width: "64.9%", height: "100.5%"}}>
                        <header className={'instance-layout-grid-header'}>
                            <h5>{isAttributesGrid ? `${selectedRelationTypeNode ? selectedRelationTypeNode.data.type : ''} Attributes` : 'Related Records'}</h5>
                        </header>
                        <div id={"relationships"} className={"ag-theme-balham-dark ag-grids"}
                             style={{width: "100%", height: "calc(100% - 40px)"}} />
                    </div>
                </div>
                <div style={{background: "#2D3436",  borderTop: "2px solid #f5f5f5a3", height: 45, width: "100%", paddingRight: 5, paddingTop: 3}}>
                    {!isAttributesGrid ? <React.Fragment>
                        <button
                            onClick={() => {
                                hide();
                            }}
                            className={"btn"}
                            style={{float: "right", marginTop: 3, marginRight: 2}}>
                            <i className="fas fa-times"> Close</i>
                        </button>
                        <button
                            onClick={onSave}
                            className={"btn"}
                            style={{float: "right", marginTop: 3, marginRight: 2}}>
                            <i className="fas fa-save"> Save</i>
                        </button>
                        <button
                            onClick={onOpenImportDialog}
                            className={"btn"}
                            style={{float: "right", marginTop: 3, marginRight: 2}}>
                            <i className="fas fa-upload"> Import</i>
                        </button>
                    </React.Fragment> :
                        <React.Fragment>
                            <button
                                onClick={() => submitNaturalKeys()}
                                className={"btn"}
                                style={{float: "right", marginTop: 3, marginRight: 2}}>
                                <i className="fas fa-save"> Submit</i>
                            </button>
                        </React.Fragment>
                    }
                </div>
            </div>
        </Modal>
    );
});

export default RelationshipsModal;



// WEBPACK FOOTER //
// ./app/components/bo-core/modals/RelationshipsModal.tsx